import MapMenu from '../lib/map_menu';

export default class GenderNeutralRestroomsLayer {
	constructor() {
		this.checkboxEl = document.getElementById('gender-neutral-restrooms-layer');
		this.visible = false;
	}

	add() {
		const url = W.api_root + 'gender_neutral_restrooms.geojson';
		if (!W.map.getSource('gender_neutral_restrooms-source')) {
			W.map.addSource('gender_neutral_restrooms-source', {
				type: 'geojson',
				data: url,
			});
		}

		W.map.addLayer({
			id: 'gender_neutral_restrooms-layer',
			type: 'symbol',
			source: 'gender_neutral_restrooms-source',
			layout: {
				'icon-image': 'marker-restroom',
				'icon-offset': [0, 0],
				'icon-anchor': 'bottom',
				'icon-size': 1.5,
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
			},
		});
		this.visible = true;
		W.LayerUtils.setView('gender_neutral_restrooms-layer');
		MapMenu.hide();
	}

	remove() {
		W.map.removeLayer('gender_neutral_restrooms-layer');
		this.visible = false;
	}
}
